namespace GeniuzPOS.AdvPromo {
    export interface PsAdvPromoItem6Form {
        PmGroupId: Serenity.StringEditor;
        PmId: Serenity.StringEditor;
        PmType: Serenity.IntegerEditor;
        PmExtCode: Serenity.StringEditor;
        BundleItemNo: Serenity.IntegerEditor;
        PmStepNo: Serenity.IntegerEditor;
        PmDesc: Serenity.StringEditor;
        PmOrder: Serenity.IntegerEditor;
        LineItemNo: Serenity.IntegerEditor;
        ItemType: Serenity.EnumEditor;
        NpcsOrBundlePrice: Serenity.DecimalEditor;
        BuncleQty: Serenity.DecimalEditor;
        Amt: Serenity.DecimalEditor;
        BundleUnitPrice: Serenity.DecimalEditor;
        BundleExPrice: Serenity.DecimalEditor;
        AssortFg: Serenity.RadioButtonEditor;
        ListFg: Serenity.RadioButtonEditor;
        PluCode: Serenity.LookupEditor;
        StyleCode: Serenity.LookupEditor;
        BrandCode: Serenity.LookupEditor;
        CatCode: Serenity.LookupEditor;
        SubCat1Code: Serenity.LookupEditor;
        SubCat2Code: Serenity.LookupEditor;
        SupplCode: Serenity.LookupEditor;
    }

    export class PsAdvPromoItem6Form extends Serenity.PrefixedContext {
        static formKey = 'AdvPromo.PsAdvPromoItem6';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsAdvPromoItem6Form.init)  {
                PsAdvPromoItem6Form.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.EnumEditor;
                var w3 = s.DecimalEditor;
                var w4 = s.RadioButtonEditor;
                var w5 = s.LookupEditor;

                Q.initFormType(PsAdvPromoItem6Form, [
                    'PmGroupId', w0,
                    'PmId', w0,
                    'PmType', w1,
                    'PmExtCode', w0,
                    'BundleItemNo', w1,
                    'PmStepNo', w1,
                    'PmDesc', w0,
                    'PmOrder', w1,
                    'LineItemNo', w1,
                    'ItemType', w2,
                    'NpcsOrBundlePrice', w3,
                    'BuncleQty', w3,
                    'Amt', w3,
                    'BundleUnitPrice', w3,
                    'BundleExPrice', w3,
                    'AssortFg', w4,
                    'ListFg', w4,
                    'PluCode', w5,
                    'StyleCode', w5,
                    'BrandCode', w5,
                    'CatCode', w5,
                    'SubCat1Code', w5,
                    'SubCat2Code', w5,
                    'SupplCode', w5
                ]);
            }
        }
    }
}
